module.exports = __webpack_public_path__ + "static/harvey-norman-b0262affcf238061044ced3827b4f6d1.png";